import React, { useReducer, useEffect } from "react";
import { Col, Row, Accordion, Button, Alert, Card } from "react-bootstrap";
import StatsListing from "../shared/infoListing/StatsListing";
import ActivityRecentRegistrations from "../../modules/activities/partials/details/ActivityRecentRegistrations";
import axios from "axios";
import {
  dashboardInitialState,
  dashboardReducer,
} from "../../modules/activities/reducers/dashboardReducer";
import { Link, useParams } from "react-router-dom";
import axiosInstance from "../../../config/axios";
import { ContainerLoading } from "../loading/ContainerLoading";
import { FullPageOverlay } from "../loading/FullPageOverlay";
import { getCurrencyCode } from "../../../helpers/CommonHelper";
import { HiCurrencyDollar } from "react-icons/hi2";
import { RiFileWarningFill } from "react-icons/ri";
import { FaUserClock } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
function CollapseActivity() {
  const [detailsState, detailsDispatch] = useReducer(
    dashboardReducer,
    dashboardInitialState
  );
  const navigate = useNavigate();

  const handleClick = (guest, kid,id) => {
    
      navigate(`/activity-registrations/${id}`);
    
  };
  const handleNavigate = (url) => {

    navigate(url);

  };
  const sleep = (ms) => {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  };
  const loadItem = async () => {
    detailsDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axiosInstance.get(`activities/stats-for-dashboard`);
      detailsDispatch({
        type: "FETCH_SUCCESS",
        payload: res.data,
      });
      console.log(res.data, "77777");
    } catch (error) {
      detailsDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  };
  useEffect(() => {
    loadItem();
  }, []);

  return (
    <>
      {detailsState.isFetching === true && <FullPageOverlay />}

      {detailsState.isFetching !== true &&
        detailsState.data &&
        detailsState.data.recentItems &&
        detailsState.data.recentItems.map((item, index) => {
          <p>{index}</p>;
        })}

      {detailsState.data && detailsState.data.summary && (
        <>
          <Card className="mt-xl-0 mt-lg-0 mt-md-0 mt-2 mb-xl-0 mb-lg-0 mb-md-0 border-themePrimary">
            <Card.Body className="p-xl-2 px-lg-2 px-md-2 p-0">
              <Row className="showOnMobile bg-themePrimary text-center w-100 mx-auto">
                <Col>
                  <h5 className="my-3  px-1 text-bold text-themePrimary">
                    Activities
                  </h5>
                </Col>
              </Row>
              <Row className="mt-xl-3 mt-lg-3 mt-md-3 mt-1 px-1 ">
                <Col xl={3} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={()=> handleNavigate("/activities")}>
                  <a
                   
                    className="d-flex h-100 w-100"
                  >
                    <div class="dashboard-box bg-linear-five ">
                      <div class="dashboard-box-icon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <div>
                        <h5 class="dashboard-box-heading d-flex flex-column ">
                          <span className="fs-5 font-weight-bold mb-1 ">
                            {detailsState.data.summary.total}
                          </span>{" "}
                          Total Activity(s)
                        </h5>
                      </div>
                    </div>
                  </a>
                </Col>
                <Col xl={3} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={()=> handleNavigate("/activities?pastActivity=0")}>
                  <a
                  
                    className="d-flex h-100 w-100"
                  >
                    <div class="dashboard-box bg-linear-six ">
                      <div class="dashboard-box-icon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <div>
                        <h5 class="dashboard-box-heading d-flex flex-column ">
                          <span className="fs-5 font-weight-bold mb-1 ">
                            {detailsState.data.summary.upcoming}
                          </span>{" "}
                          Upcoming Activity(s)
                        </h5>
                      </div>
                    </div>
                  </a>
                </Col>
                <Col xl={3} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={()=> handleNavigate("/activities?pastActivity=1")}>
                  <a
                  
                    className="d-flex h-100 w-100"
                  >
                    <div class="dashboard-box bg-linear-black ">
                      <div class="dashboard-box-icon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <div>
                        <h5 class="dashboard-box-heading d-flex flex-column ">
                          <span className="fs-5 font-weight-bold mb-1 ">
                            {detailsState.data.summary.past}
                          </span>{" "}
                          Past Activity(s)
                        </h5>
                      </div>
                    </div>
                  </a>
                </Col>
                <Col xl={3} lg={4} md={4} sm={6} xs={12} className="flex-1 animate cursor-pointer" onClick={()=> handleNavigate("/activities?status=0")}>
                  <a
                    
                    className="d-flex h-100 w-100"
                  >
                    <div class="dashboard-box bg-linear-fourteen ">
                      <div class="dashboard-box-icon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <div>
                        <h5 class="dashboard-box-heading d-flex flex-column ">
                          <span className="fs-5 font-weight-bold mb-1 ">
                            {detailsState.data.summary.disabled}
                          </span>{" "}
                          Disabled Activity(s)
                        </h5>
                      </div>
                    </div>
                  </a>
                </Col>
              </Row>
              {detailsState.data.activities && detailsState.data.activities.length > 0 && <>
                <Row>

                  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                    <Card className="mb-2 bg-linear-one">
                      <Card.Body className="pb-0">
                        <div className="d-flex align-items-start justify-content-between">
                          <div>
                            <h5 className=" text-white fs-9 mb-3 ">Registration Summary</h5>
                            {/* <p className="mb-0 text-white fontBoldItalic fs-12 text-left heartbeat hide  mb-0">Admin Action Required</p> */}
                          </div>
                          <div>
                            <Link to={"/activities"} className="btn btn-xs btn-light fontItalic"> View More</Link>
                          </div>

                        </div>

                        <div className="overflow-x-auto mt-0">

                          <table className="table-auto w-100 mt-6 border-collapse">
                            <thead className="">
                              <th className="text-white fontItalic font-weight-normal py-1">Activity</th>
                              <th className="text-white text-center fontItalic font-weight-normal py-1">Admin Approval pending</th>
                              <th className="text-white text-right fontItalic font-weight-normal py-1">Registrations</th>

                            </thead>

                            <tbody>
                              {detailsState.data.activities.map((item, index) => {
                                return (
                                  <tr onClick={() => handleClick(item.stats.guestsAdminApprovalPending, item.stats.kidsAdminApprovalPending,item._id)}
                                   className={"cursor-pointer animate cursor-pointer border-top border-bottom "} 
                                   title={item.stats.guestsAdminApprovalPending > 0 || item.stats.kidsAdminApprovalPending > 0 ? "Click to Approve/Reject Request" : "View details"}>
                                    <td className="px-1 py-1 flex items-center gap-2">

                                      <span className="fontBoldItalic text-white">{item.title}</span>
                                      <p className="mb-2 fontItalic fs-12 text-white">{item.date}, {item.location}</p>
                                    </td>

                                    <td className="px-1 py-1 " >

                                      <div className="d-flex align-items-center justify-content-center text-white mt-1">

                                        <div className={`holder dashboard`}>
                                          <p className="title text-white ">Guests: </p>
                                          <p className="value text-white ms-2 "> {item.stats.guestsAdminApprovalPending}</p>
                                        </div>
                                        <div className={`holder text-white border-0`}>
                                          <p className="title text-white ">Kids: </p>
                                          <p className="value ms-2 text-white"> {item.stats.kidsAdminApprovalPending}</p>
                                        </div>
                                      </div>
                                      {item.stats.guestsAdminApprovalPending > 0 || item.stats.kidsAdminApprovalPending > 0 &&
                                        <p className="mb-0 text-white fontBoldItalic fs-12 text-center heartbeat  mb-0">Admin Action Required</p>}
                                    </td>
                                    <td className="px-1 py-1 ">
                                      <div className="d-flex align-items-center justify-content-end text-white mt-1">

                                        <div className={`holder dashboard border-0`}>
                                          <p className="title text-white ">Total Registrations: </p>
                                          <p className="value text-white ms-2 ">{item.stats.totalUniqueRequests}</p>
                                        </div>

                                      </div>
                                      {/* <div className="d-flex align-items-center justify-content-end text-white mt-1">

                                        <div className={`holder dashboard`}>
                                          <p className="title text-white ">Confirmed: </p>
                                          <p className="value text-white ms-2 ">{item.stats.totalConfirmedParticipants}</p>
                                        </div>
                                        <div className={`holder text-white border-0`}>
                                          <p className="title text-white ">Not Confirmed: </p>
                                          <p className="value ms-2 text-white">{item.stats.totalNotConfirmedParticipants}</p>
                                        </div>
                                      </div> */}

                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          </table>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </>}
              {/* {detailsState.data &&
                detailsState.data.summary &&
                detailsState.data.summary.total > 0 && (
                  <Row className="my-2 p-xl-0 px-lg-0 px-md-0 px-1">
                    <Col>
                      <Button
                        variant="primary"
                        className="float-end"
                        size="sm"
                        href={`/activities`}
                      >
                        View All
                      </Button>
                    </Col>
                  </Row>
                )} */}
              {/* {detailsState.data.summary.upcoming > 0 && (
                <Row className="hideOnMobile d-flex align-items-center justify-content-center px-1">
                  <Col>
                    <h5 className="my-3  px-1 text-bold">
                      {" "}
                      Upcoming Activity(s)
                    </h5>
                  </Col>
                  <Col>
                    {detailsState.data &&
                      detailsState.data.summary &&
                      detailsState.data.summary.total > 0 && (
                        <Row className="my-1 p-xl-0 px-lg-0 px-md-0 px-1">
                          <Col>
                            <Button
                              variant="primary"
                              className="float-end"
                              size="sm"
                              href={`/activities`}
                            >
                              View All
                            </Button>
                          </Col>
                        </Row>
                      )}
                  </Col>
                </Row>
              )}
              {detailsState.data &&
                detailsState.data.recentItems &&
                detailsState.data.recentItems.length <= 0 && (
                  <Alert variant="warning mb-0 mt-1">No records found.</Alert>
                )}

              {detailsState.data &&
                detailsState.data.recentItems &&
                detailsState.data.recentItems.length > 0 && (
                  <>
                    {detailsState.data.recentItems.map((item, index) => {
                      return (
                        <Card className="borderTopRed hideOnMobile">
                          <Card.Header className="py-0 px-1">
                            <div className="card-title">
                              <p className="mb-0 text-bold text-white">
                                <a
                                  href={`/activities/${item._id}`}
                                  className="hoveredText "
                                >
                                  {item.title}
                                </a>
                              </p>
                              <p className="mb-0 font-small text-success">
                                {item.date}
                              </p>
                            </div>
                            <div className="card-tools"></div>
                          </Card.Header>
                          <Card.Body className="p-0">
                            <StatsListing
                              heading="Stats"
                              items={[
                                {
                                  text: "Registrations Count",
                                  value: item.stats.registrationsCount,
                                },
                                {
                                  text: "Confirmed Registrations",
                                  value: item.stats.registrationsCountConfirmed,
                                },
                                {
                                  text: "Not Confirmed Registrations",
                                  value:
                                    item.stats.registrationsCountNotConfirmed,
                                },
                              ]}
                            />
                          </Card.Body>
                        </Card>
                      );
                    })}
                  </>
                )} */}
            </Card.Body>
          </Card>
        </>
      )}
    </>
  );
}

export default CollapseActivity;
